import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from '../HtmlContent';
import NavButton from '../../elements/NavButton';

export default class Prize extends React.Component {
  render() {
    const {
      content,
      nextStep,
      nextStepHandler,
      closeHandler,
    } = this.props;
    const {
      AdventCount: {
        translations: {
          common: {
            next,
            close,
          },
        },
      },
    } = window;

    return (
      <div className="adventcount-modal intro">
        <HtmlContent content={content} />
        <div className="adventcount-button-row">
          <NavButton
            toStep=""
            btnLabel={close}
            direction="close"
            clickHandler={closeHandler}
          />
          <NavButton
            toStep={nextStep}
            btnLabel={next}
            direction="next"
            clickHandler={nextStepHandler}
          />
        </div>
      </div>
    );
  }
}

Prize.propTypes = {
  content: PropTypes.string.isRequired,
  nextStep: PropTypes.string.isRequired,
  nextStepHandler: PropTypes.func.isRequired,
  closeHandler: PropTypes.func.isRequired,
};
